<template lang="pug">
  .wrap
    h1 Your weekly roundup

    .widget
      briefs-chart(:options="{responsive: false, maintainAspectRatio: false}" :width="400" :height="100")

</template>

<script>
import BriefsChart from "@/components/pages/dashboardCharts/BriefsChart";

export default {
  components: { BriefsChart }
};
</script>

<style scoped lang="scss">
.wrap {
  padding: 20px;
  background: #eee;
}

.widget {
  background: white;
  padding: 20px;
}
</style>
